// extracted by mini-css-extract-plugin
module.exports = {"AccordionItem":"AccordionItem_AccordionItem__aydja","top":"AccordionItem_top__CuSMl","description":"AccordionItem_description__3bYJN"};